const util = {};
util.getListMap = function (list) {
  const newObj = {};
  list.forEach((item) => {
    newObj[item['value']] = item['name'];
  });
  return newObj;
};
export default util;
